import React from 'react';
import useScrollFadeIn from '../hooks/useScrollFadeIn';
import { featureMetrics } from '../data/stats';

/* ---------- SVG Illustrations ---------- */

function AIWhatsAppRepliesSVG() {
  return (
    <svg viewBox="0 0 400 300" className="w-full max-w-md" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Phone with AI chat bubbles showing automated WhatsApp replies">
      <defs>
        <linearGradient id="grad-replies" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      {/* Phone body */}
      <rect x="110" y="20" width="180" height="260" rx="20" fill="#e0e7ff" stroke="#6366f1" strokeWidth="2" />
      <rect x="120" y="50" width="160" height="210" rx="4" fill="#ffffff" />
      {/* Earpiece */}
      <rect x="175" y="30" width="50" height="6" rx="3" fill="#c7d2fe" />
      {/* User bubble (right) */}
      <rect x="190" y="75" width="76" height="32" rx="12" fill="#f1f5f9" />
      <rect x="198" y="85" width="42" height="5" rx="2.5" fill="#cbd5e1" />
      <rect x="198" y="94" width="28" height="4" rx="2" fill="#e2e8f0" />
      {/* AI bubble (left) */}
      <rect x="134" y="120" width="100" height="44" rx="12" fill="url(#grad-replies)" />
      <rect x="146" y="131" width="56" height="5" rx="2.5" fill="#e0e7ff" />
      <rect x="146" y="140" width="72" height="5" rx="2.5" fill="#e0e7ff" />
      <rect x="146" y="149" width="40" height="4" rx="2" fill="#c7d2fe" />
      {/* Sparkles near AI bubble */}
      <polygon points="240,118 243,126 251,126 245,131 247,139 240,134 233,139 235,131 229,126 237,126" fill="#8b5cf6" opacity="0.6" />
      <polygon points="255,140 257,145 262,145 258,148 259,153 255,150 251,153 252,148 248,145 253,145" fill="#6366f1" opacity="0.4" />
      {/* Second user bubble */}
      <rect x="178" y="180" width="90" height="28" rx="12" fill="#f1f5f9" />
      <rect x="188" y="189" width="50" height="5" rx="2.5" fill="#cbd5e1" />
      <rect x="188" y="198" width="32" height="4" rx="2" fill="#e2e8f0" />
      {/* Second AI bubble */}
      <rect x="134" y="218" width="80" height="28" rx="12" fill="url(#grad-replies)" />
      <rect x="146" y="227" width="52" height="5" rx="2.5" fill="#e0e7ff" />
      <rect x="146" y="236" width="36" height="4" rx="2" fill="#c7d2fe" />
      {/* WhatsApp indicator */}
      <circle cx="275" cy="35" r="12" fill="#22c55e" />
      <path d="M270,35 a7,7 0 1,1 10,4 l1,4 -4,-2 a7,7 0 0,1-7,-6z" fill="#ffffff" opacity="0.9" />
    </svg>
  );
}

function KnowledgeBaseSVG() {
  return (
    <svg viewBox="0 0 400 300" className="w-full max-w-md" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Documents flowing into a brain representing knowledge base training">
      <defs>
        <linearGradient id="grad-knowledge" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      {/* Back document */}
      <rect x="48" y="50" width="130" height="170" rx="8" fill="#e0e7ff" stroke="#c7d2fe" strokeWidth="1.5" />
      <rect x="66" y="80" width="60" height="5" rx="2.5" fill="#c7d2fe" />
      <rect x="66" y="92" width="80" height="5" rx="2.5" fill="#c7d2fe" />
      <rect x="66" y="104" width="50" height="5" rx="2.5" fill="#c7d2fe" />
      {/* Middle document */}
      <rect x="62" y="38" width="130" height="170" rx="8" fill="#eef2ff" stroke="#c7d2fe" strokeWidth="1.5" />
      <rect x="80" y="68" width="60" height="5" rx="2.5" fill="#c7d2fe" />
      <rect x="80" y="80" width="80" height="5" rx="2.5" fill="#c7d2fe" />
      <rect x="80" y="92" width="50" height="5" rx="2.5" fill="#c7d2fe" />
      <rect x="80" y="110" width="70" height="5" rx="2.5" fill="#e0e7ff" />
      <rect x="80" y="122" width="90" height="5" rx="2.5" fill="#e0e7ff" />
      {/* Front document */}
      <rect x="76" y="26" width="130" height="170" rx="8" fill="#ffffff" stroke="#6366f1" strokeWidth="1.5" />
      <rect x="94" y="50" width="50" height="6" rx="3" fill="#6366f1" opacity="0.7" />
      <rect x="94" y="66" width="90" height="5" rx="2.5" fill="#e0e7ff" />
      <rect x="94" y="78" width="70" height="5" rx="2.5" fill="#e0e7ff" />
      <rect x="94" y="90" width="80" height="5" rx="2.5" fill="#e0e7ff" />
      <rect x="94" y="108" width="60" height="5" rx="2.5" fill="#c7d2fe" />
      <rect x="94" y="120" width="90" height="5" rx="2.5" fill="#c7d2fe" />
      <rect x="94" y="132" width="40" height="5" rx="2.5" fill="#c7d2fe" />
      {/* Curved arrow */}
      <path d="M220,130 C240,130 260,110 280,100 C300,90 310,100 310,120" stroke="#6366f1" strokeWidth="2.5" strokeDasharray="6 3" fill="none" />
      <polygon points="305,122 310,134 316,120" fill="#6366f1" />
      {/* Brain shape */}
      <path d="M310,140 C290,135 280,150 285,165 C275,170 275,190 290,195 C288,210 300,220 315,215 C325,225 345,220 348,208 C360,210 370,198 365,185 C378,178 375,160 362,155 C370,142 360,130 345,132 C338,122 320,122 310,140Z" fill="url(#grad-knowledge)" opacity="0.85" />
      {/* Brain detail lines */}
      <path d="M310,160 C320,155 330,165 325,175 C335,172 340,185 330,190" stroke="#e0e7ff" strokeWidth="1.5" fill="none" />
      <path d="M340,150 C345,160 342,172 350,175" stroke="#e0e7ff" strokeWidth="1.5" fill="none" />
      {/* Small sparkles */}
      <circle cx="300" cy="130" r="3" fill="#8b5cf6" opacity="0.5" />
      <circle cx="360" cy="142" r="2" fill="#6366f1" opacity="0.4" />
    </svg>
  );
}

function LeadCaptureSVG() {
  return (
    <svg viewBox="0 0 400 300" className="w-full max-w-md" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Funnel directing leads into a contact form">
      <defs>
        <linearGradient id="grad-lead" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      {/* Funnel */}
      <path d="M40,60 L130,60 L100,140 L70,140 Z" fill="#eef2ff" stroke="#6366f1" strokeWidth="1.5" />
      <path d="M70,140 L100,140 L92,180 L78,180 Z" fill="#e0e7ff" stroke="#6366f1" strokeWidth="1.5" />
      {/* Person silhouettes entering funnel */}
      <circle cx="65" cy="38" r="10" fill="#c7d2fe" />
      <path d="M55,52 C55,48 60,44 65,44 C70,44 75,48 75,52 L75,60 L55,60Z" fill="#c7d2fe" />
      <circle cx="95" cy="32" r="10" fill="#8b5cf6" opacity="0.5" />
      <path d="M85,46 C85,42 90,38 95,38 C100,38 105,42 105,46 L105,54 L85,54Z" fill="#8b5cf6" opacity="0.5" />
      {/* Arrow from funnel to form */}
      <path d="M100,180 C100,210 130,220 160,210" stroke="#6366f1" strokeWidth="2" strokeDasharray="5 3" fill="none" />
      <polygon points="160,205 172,210 160,216" fill="#6366f1" />
      {/* Form card */}
      <rect x="175" y="50" width="190" height="220" rx="12" fill="#ffffff" stroke="#e0e7ff" strokeWidth="2" />
      {/* Form header */}
      <rect x="195" y="70" width="80" height="8" rx="4" fill="#6366f1" opacity="0.8" />
      {/* Name field */}
      <rect x="195" y="100" width="40" height="5" rx="2.5" fill="#94a3b8" />
      <rect x="195" y="112" width="150" height="32" rx="6" fill="#f1f5f9" stroke="#e0e7ff" strokeWidth="1" />
      <rect x="207" y="124" width="60" height="5" rx="2.5" fill="#cbd5e1" />
      {/* Email field */}
      <rect x="195" y="155" width="30" height="5" rx="2.5" fill="#94a3b8" />
      <rect x="195" y="167" width="150" height="32" rx="6" fill="#f1f5f9" stroke="#e0e7ff" strokeWidth="1" />
      <rect x="207" y="179" width="80" height="5" rx="2.5" fill="#cbd5e1" />
      {/* Phone field */}
      <rect x="195" y="210" width="35" height="5" rx="2.5" fill="#94a3b8" />
      <rect x="195" y="222" width="150" height="32" rx="6" fill="#f1f5f9" stroke="#e0e7ff" strokeWidth="1" />
      <rect x="207" y="234" width="55" height="5" rx="2.5" fill="#cbd5e1" />
    </svg>
  );
}

function AppointmentBookingSVG() {
  return (
    <svg viewBox="0 0 400 300" className="w-full max-w-md" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Calendar with highlighted dates and clock for appointment booking">
      <defs>
        <linearGradient id="grad-appt" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      {/* Calendar frame */}
      <rect x="50" y="40" width="230" height="220" rx="14" fill="#ffffff" stroke="#e0e7ff" strokeWidth="2" />
      {/* Header bar */}
      <rect x="50" y="40" width="230" height="48" rx="14" fill="url(#grad-appt)" />
      <rect x="50" y="74" width="230" height="14" fill="url(#grad-appt)" />
      {/* Header text lines */}
      <rect x="100" y="54" width="80" height="7" rx="3.5" fill="#e0e7ff" />
      {/* Left/right nav arrows */}
      <polygon points="72,58 82,52 82,64" fill="#e0e7ff" />
      <polygon points="258,58 248,52 248,64" fill="#e0e7ff" />
      {/* Day labels */}
      {['S','M','T','W','T','F','S'].map((d, i) => (
        <text key={i} x={78 + i * 28} y="102" fontSize="9" fill="#94a3b8" textAnchor="middle" fontFamily="sans-serif" fontWeight="600">{d}</text>
      ))}
      {/* Date grid: 4 rows x 7 cols */}
      {[0, 1, 2, 3].map(row =>
        [0, 1, 2, 3, 4, 5, 6].map(col => {
          const num = row * 7 + col + 1;
          if (num > 28) return null;
          const cx = 78 + col * 28;
          const cy = 128 + row * 32;
          const isHighlighted = num === 10 || num === 15 || num === 22;
          return (
            <React.Fragment key={`${row}-${col}`}>
              {isHighlighted ? (
                <>
                  <rect x={cx - 12} y={cy - 11} width="24" height="22" rx="6" fill="url(#grad-appt)" />
                  <text x={cx} y={cy + 4} fontSize="10" fill="#ffffff" textAnchor="middle" fontFamily="sans-serif" fontWeight="600">{num}</text>
                </>
              ) : (
                <text x={cx} y={cy + 4} fontSize="10" fill="#64748b" textAnchor="middle" fontFamily="sans-serif">{num}</text>
              )}
            </React.Fragment>
          );
        })
      )}
      {/* Checkmark on cell 15 */}
      <polyline points="157,146 162,152 172,140" stroke="#ffffff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      {/* Clock overlay */}
      <circle cx="330" cy="110" r="44" fill="#eef2ff" stroke="#6366f1" strokeWidth="2" />
      <circle cx="330" cy="110" r="3" fill="#6366f1" />
      <line x1="330" y1="110" x2="330" y2="80" stroke="#6366f1" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="330" y1="110" x2="352" y2="118" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" />
      {/* Hour marks */}
      {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map(deg => {
        const rad = (deg * Math.PI) / 180;
        const x1 = 330 + 38 * Math.sin(rad);
        const y1 = 110 - 38 * Math.cos(rad);
        const x2 = 330 + 42 * Math.sin(rad);
        const y2 = 110 - 42 * Math.cos(rad);
        return <line key={deg} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#c7d2fe" strokeWidth="1.5" />;
      })}
      {/* Notification badge */}
      <circle cx="360" cy="78" r="10" fill="#6366f1" />
      <text x="360" y="82" fontSize="10" fill="#ffffff" textAnchor="middle" fontFamily="sans-serif" fontWeight="700">!</text>
    </svg>
  );
}

function EmailSendingSVG() {
  return (
    <svg viewBox="0 0 400 300" className="w-full max-w-md" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Envelope with paper plane for automated email sending">
      <defs>
        <linearGradient id="grad-email" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      {/* Envelope body */}
      <rect x="60" y="90" width="220" height="150" rx="12" fill="url(#grad-email)" />
      {/* Envelope flap (triangle) */}
      <path d="M60,90 L170,175 L280,90" fill="#8b5cf6" stroke="#6366f1" strokeWidth="1" />
      {/* Inner lighter triangle for depth */}
      <path d="M72,98 L170,168 L268,98" fill="none" stroke="#e0e7ff" strokeWidth="1" opacity="0.5" />
      {/* Letter peeking out */}
      <rect x="90" y="70" width="160" height="80" rx="6" fill="#ffffff" stroke="#e0e7ff" strokeWidth="1" />
      <rect x="108" y="86" width="80" height="5" rx="2.5" fill="#e0e7ff" />
      <rect x="108" y="96" width="110" height="5" rx="2.5" fill="#eef2ff" />
      <rect x="108" y="106" width="60" height="5" rx="2.5" fill="#eef2ff" />
      {/* Paper plane emerging */}
      <path d="M290,80 L340,50 L320,90 L305,78 Z" fill="#6366f1" opacity="0.85" />
      <path d="M305,78 L340,50 L320,90" fill="#8b5cf6" opacity="0.7" />
      {/* Motion lines */}
      <line x1="300" y1="72" x2="330" y2="55" stroke="#c7d2fe" strokeWidth="1.5" strokeDasharray="4 3" />
      <line x1="305" y1="85" x2="340" y2="72" stroke="#c7d2fe" strokeWidth="1" strokeDasharray="3 3" />
      {/* Notification circles */}
      <circle cx="55" cy="80" r="6" fill="#8b5cf6" opacity="0.25" />
      <circle cx="38" cy="120" r="4" fill="#6366f1" opacity="0.2" />
      <circle cx="300" cy="110" r="5" fill="#8b5cf6" opacity="0.3" />
      <circle cx="320" cy="140" r="3" fill="#6366f1" opacity="0.2" />
      <circle cx="350" cy="40" r="4" fill="#8b5cf6" opacity="0.35" />
      <circle cx="360" cy="70" r="3" fill="#6366f1" opacity="0.25" />
      {/* Bottom envelope shadow */}
      <ellipse cx="170" cy="248" rx="100" ry="6" fill="#c7d2fe" opacity="0.3" />
    </svg>
  );
}

function AlwaysOnSVG() {
  return (
    <svg viewBox="0 0 400 300" className="w-full max-w-md" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Clock with sun and moon showing 24/7 availability">
      <defs>
        <linearGradient id="grad-always" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      {/* Outer dashed ring */}
      <circle cx="200" cy="130" r="90" fill="none" stroke="#c7d2fe" strokeWidth="2" strokeDasharray="8 6" />
      {/* Clock face */}
      <circle cx="200" cy="130" r="72" fill="#eef2ff" stroke="#6366f1" strokeWidth="2.5" />
      {/* Hour marks */}
      {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map(deg => {
        const rad = (deg * Math.PI) / 180;
        const isMajor = deg % 90 === 0;
        const inner = isMajor ? 58 : 62;
        const outer = 68;
        const x1 = 200 + inner * Math.sin(rad);
        const y1 = 130 - inner * Math.cos(rad);
        const x2 = 200 + outer * Math.sin(rad);
        const y2 = 130 - outer * Math.cos(rad);
        return <line key={deg} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#6366f1" strokeWidth={isMajor ? 2.5 : 1.5} strokeLinecap="round" />;
      })}
      {/* Clock center */}
      <circle cx="200" cy="130" r="4" fill="url(#grad-always)" />
      {/* Hour hand */}
      <line x1="200" y1="130" x2="200" y2="85" stroke="#6366f1" strokeWidth="3" strokeLinecap="round" />
      {/* Minute hand */}
      <line x1="200" y1="130" x2="232" y2="110" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" />
      {/* Sun (right side) */}
      <circle cx="330" cy="90" r="18" fill="#fbbf24" opacity="0.8" />
      {[0, 45, 90, 135, 180, 225, 270, 315].map(deg => {
        const rad = (deg * Math.PI) / 180;
        const x1 = 330 + 24 * Math.sin(rad);
        const y1 = 90 - 24 * Math.cos(rad);
        const x2 = 330 + 32 * Math.sin(rad);
        const y2 = 90 - 32 * Math.cos(rad);
        return <line key={deg} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" opacity="0.7" />;
      })}
      {/* Moon (left side) */}
      <path d="M70,90 A22,22 0 1,1 70,134 A16,16 0 1,0 70,90Z" fill="#8b5cf6" opacity="0.6" />
      {/* Small stars near moon */}
      <circle cx="48" cy="80" r="2" fill="#c7d2fe" />
      <circle cx="55" cy="145" r="1.5" fill="#c7d2fe" />
      <circle cx="38" cy="115" r="1.5" fill="#e0e7ff" />
      {/* 24/7 text below */}
      <text x="200" y="258" fontSize="28" fill="#6366f1" textAnchor="middle" fontFamily="sans-serif" fontWeight="800">24/7</text>
      {/* Subtle underline accent */}
      <rect x="170" y="266" width="60" height="3" rx="1.5" fill="url(#grad-always)" opacity="0.5" />
    </svg>
  );
}

function LocalTestingSVG() {
  return (
    <svg viewBox="0 0 400 300" className="w-full max-w-md" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Browser window with chat interface and test badge for local testing">
      <defs>
        <linearGradient id="grad-test" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      {/* Browser window frame */}
      <rect x="40" y="30" width="320" height="230" rx="12" fill="#ffffff" stroke="#e0e7ff" strokeWidth="2" />
      {/* Title bar */}
      <rect x="40" y="30" width="320" height="36" rx="12" fill="#f1f5f9" />
      <rect x="40" y="54" width="320" height="12" fill="#f1f5f9" />
      {/* Window control dots */}
      <circle cx="62" cy="48" r="5" fill="#f87171" opacity="0.8" />
      <circle cx="80" cy="48" r="5" fill="#fbbf24" opacity="0.8" />
      <circle cx="98" cy="48" r="5" fill="#4ade80" opacity="0.8" />
      {/* URL bar */}
      <rect x="120" y="40" width="180" height="16" rx="8" fill="#ffffff" stroke="#e0e7ff" strokeWidth="1" />
      <rect x="132" y="46" width="80" height="4" rx="2" fill="#cbd5e1" />
      {/* Content area */}
      <rect x="60" y="80" width="280" height="162" rx="4" fill="#eef2ff" />
      {/* Chat preview inside browser */}
      {/* User message */}
      <rect x="170" y="100" width="100" height="28" rx="10" fill="#f1f5f9" stroke="#e0e7ff" strokeWidth="1" />
      <rect x="182" y="109" width="56" height="4" rx="2" fill="#cbd5e1" />
      <rect x="182" y="117" width="36" height="4" rx="2" fill="#e2e8f0" />
      {/* Bot message */}
      <rect x="80" y="140" width="120" height="36" rx="10" fill="url(#grad-test)" />
      <rect x="94" y="150" width="70" height="4" rx="2" fill="#e0e7ff" />
      <rect x="94" y="158" width="86" height="4" rx="2" fill="#e0e7ff" />
      <rect x="94" y="166" width="48" height="4" rx="2" fill="#c7d2fe" />
      {/* Input bar */}
      <rect x="80" y="195" width="200" height="28" rx="8" fill="#ffffff" stroke="#c7d2fe" strokeWidth="1" />
      <rect x="94" y="206" width="60" height="4" rx="2" fill="#e2e8f0" />
      {/* Send button */}
      <rect x="286" y="195" width="36" height="28" rx="8" fill="url(#grad-test)" />
      <polygon points="298,204 310,209 298,214" fill="#ffffff" />
      {/* TEST badge */}
      <rect x="296" y="74" width="56" height="22" rx="6" fill="#8b5cf6" />
      <text x="324" y="89" fontSize="10" fill="#ffffff" textAnchor="middle" fontFamily="sans-serif" fontWeight="700">TEST</text>
      {/* Green checkmark circle */}
      <circle cx="340" cy="230" r="16" fill="#22c55e" />
      <polyline points="332,230 338,236 350,224" stroke="#ffffff" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/* ---------- Feature Data ---------- */

const features = [
  {
    title: 'AI Powered WhatsApp Replies',
    description:
      'Your assistant reads and responds to customer messages instantly on WhatsApp. It handles conversations naturally, just like a real support agent, but available 24/7.',
    Illustration: AIWhatsAppRepliesSVG,
  },
  {
    title: 'Train It with Your Business Knowledge',
    description:
      'Upload your FAQs, service descriptions, policies, and pricing documents. Your AI assistant learns everything it needs to know from the files you provide.',
    Illustration: KnowledgeBaseSVG,
  },
  {
    title: 'Capture Leads Automatically',
    description:
      'When a potential customer reaches out, your assistant collects their name, email, and phone number, so you never lose a lead again.',
    Illustration: LeadCaptureSVG,
  },
  {
    title: 'Book Appointments Seamlessly',
    description:
      'Let your AI assistant schedule meetings and appointments directly through WhatsApp. Customers pick a time, and you get notified instantly.',
    Illustration: AppointmentBookingSVG,
  },
  {
    title: 'Send Emails on Your Behalf',
    description:
      'Your assistant can send follow up emails, confirmations, and updates to customers automatically, keeping communication seamless across channels.',
    Illustration: EmailSendingSVG,
  },
  {
    title: 'Always On, Always Responding',
    description:
      'Your AI assistant never sleeps, never takes a break, and never misses a message. Day or night, weekday or weekend, it\'s always there for your customers.',
    Illustration: AlwaysOnSVG,
  },
  {
    title: 'Test Before You Go Live',
    description:
      'Preview and test your AI assistant\'s responses locally before connecting it to WhatsApp. Make sure everything is perfect before your customers see it.',
    Illustration: LocalTestingSVG,
  },
];

/* ---------- Features Component ---------- */

export default function Features() {
  const { ref, isVisible } = useScrollFadeIn();

  return (
    <section id="features" className="py-20 sm:py-28 px-4 sm:px-6 lg:px-8">
      <div
        ref={ref}
        className={`transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Section heading */}
        <h2
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-16"
          style={{ color: 'var(--text-heading)' }}
        >
          Everything You Need to Automate WhatsApp
        </h2>

        {/* Feature blocks */}
        {features.map((feature, index) => {
          const { Illustration } = feature;
          const isEven = index % 2 === 1;
          const isLast = index === features.length - 1;

          return (
            <div
              key={index}
              className={!isLast ? 'border-b' : undefined}
              style={!isLast ? { borderColor: 'var(--border-feature)' } : undefined}
            >
              <div
                className={`max-w-5xl mx-auto py-12 md:py-16 flex flex-col md:flex-row items-center gap-8 md:gap-16 ${
                  isEven ? 'md:flex-row-reverse' : ''
                }`}
              >
                {/* Illustration */}
                <div className="w-full md:w-1/2 flex justify-center">
                  <div
                    className="w-full max-w-md rounded-3xl p-6 sm:p-8 flex items-center justify-center"
                    style={{
                      background: 'var(--bg-icon)',
                      border: '1px solid var(--border-card)',
                    }}
                  >
                    <Illustration />
                  </div>
                </div>

                {/* Text content */}
                <div className="w-full md:w-1/2">
                  {featureMetrics[feature.title] && (
                    <span
                      className="inline-block mb-3 text-xs font-semibold px-3 py-1 rounded-full"
                      style={{
                        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                        color: '#fff',
                      }}
                    >
                      {featureMetrics[feature.title]}
                    </span>
                  )}
                  <h3
                    className="text-2xl md:text-3xl font-bold mb-4"
                    style={{ color: 'var(--text-heading)' }}
                  >
                    {feature.title}
                  </h3>
                  <p
                    className="text-lg leading-relaxed"
                    style={{ color: 'var(--text-body)' }}
                  >
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
